import { render, staticRenderFns } from "./BuyCredits.vue?vue&type=template&id=b648e710&scoped=true&"
import script from "./BuyCredits.vue?vue&type=script&lang=js&"
export * from "./BuyCredits.vue?vue&type=script&lang=js&"
import style0 from "./BuyCredits.vue?vue&type=style&index=0&id=b648e710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b648e710",
  null
  
)

export default component.exports